/**
 * Represents the counts when callpoints are updated via import.
 */
export class ImportCallpointCounts {
   public callpointsAdded: number;
   public callpointsUpdate: number;
   public callpointsDeleted: number;
   public originalCallpointsCount: number;
}